module.exports = __webpack_public_path__ + "assets/img/202109-1W.b58a9ae9.png";